<div
  *ngIf="field"
  class="irembogov-settings-toolbar settings d-flex justify-content-end align-items-center">
  <i
    placement="auto"
    ngbTooltip="Key: {{ field.key }}"
    aria-hidden="true"
    class="icon-key-01 ms-3 copy-key-to-clipboard"
    (click)="copyFieldKeyToClipBoard()"
    (keydown)="copyFieldKeyToClipBoard()"></i>
  <i
    placement="auto"
    ngbTooltip="Clone field"
    aria-hidden="true"
    class="fas fa-clone ms-3 config-setting"
    (click)="duplicateAction()"
    (keydown)="duplicateAction()"></i>
  <i
    placement="auto"
    ngbTooltip="Configure field"
    aria-hidden="true"
    class="fas fa-cog ms-3 config-setting"
    (click)="configureField()"
    (keydown)="configureField()"></i>
  <i
    placement="auto"
    ngbTooltip="Delete field"
    aria-hidden="true"
    class="fas fa-trash-can ms-3 config-setting"
    (click)="deleteAction()"
    (keydown)="deleteAction()"></i>
  <i
    placement="auto"
    ngbTooltip="Review field"
    aria-hidden="true"
    class="fas fa-flag pointer-cursor ms-3 review-setting"
    (click)="setIssueTitleForField(label, type)"
    (keydown)="setIssueTitleForField(label, type)"></i>
</div>
